import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { XLg } from 'react-bootstrap-icons';

import {
  ModalWrapper,
  ModalCard,
  ModalContent,
  ModalClose,
  ModalButton,
} from './styles.Modal';

type ModalProps = {
  buttonText: string;
  modalParent: HTMLElement | null;
  children: React.ReactNode;
};

export const Modal: React.FC<ModalProps> = ({
  buttonText,
  modalParent,
  children,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <ModalContainer open={open} setOpen={setOpen} modalParent={modalParent}>
          {children}
        </ModalContainer>
      )}
      <ModalButton
        onClick={() => {
          setOpen(true);
        }}
      >
        {buttonText}
      </ModalButton>
    </>
  );
};

type ModalContainerProps = {
  open: boolean;
  setOpen: React.Dispatch<boolean>;
  modalParent: HTMLElement | null;
  children: React.ReactNode;
};

const ModalContainer: React.FC<ModalContainerProps> = ({
  open,
  setOpen,
  modalParent,
  children,
}) => {
  const handleClick = () => {
    setOpen(false);
  };

  const preventClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();
  };

  return ReactDOM.createPortal(
    <ModalWrapper open={open} onClick={handleClick}>
      <ModalCard>
        <ModalContent onClick={preventClick}>
          <ModalClose>
            <XLg onClick={handleClick} />
          </ModalClose>
          {children}
        </ModalContent>
      </ModalCard>
    </ModalWrapper>,
    modalParent || document.body
  );
};
